import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "incrementButton", "decrementButton", "countInputValue"];

  connect() {
    // Set initial state on connect.
    this.updateButtonStates();
  }

  increment(event) {
    const input = this.inputTarget;
    const maxValue = parseInt(input.getAttribute("max")) || Infinity;
    let currentValue = parseInt(input.value) || 0;
    if (currentValue < maxValue) {
      currentValue++;
      input.value = currentValue;
      this.updateButtonStates();
    }
  }

  decrement() {
    const input = this.inputTarget;
    const minValue = parseInt(input.getAttribute("min")) || 0;
    let currentValue = parseInt(input.value) || 0;
    if (currentValue > minValue) {
      currentValue--;
      input.value = currentValue;
      this.updateButtonStates();
    }
  }

  updateButtonStates() {
    const input = this.inputTarget;
    const minValue = parseInt(input.getAttribute("min")) || 0;
    const maxValue = parseInt(input.getAttribute("max")) || Infinity;
    const currentValue = parseInt(input.value) || 0;

    // Disable buttons based on current value.
    this.decrementButtonTarget.disabled = currentValue <= minValue;
    this.incrementButtonTarget.disabled = currentValue >= maxValue;

    // If the container should collapse when value is zero.
    if (this.element.classList.contains("count-input-collapsible")) {
      if (this.hasCountInputValueTarget) {
        if (currentValue > 0) {
          this.element.classList.remove("collapsed");
          this.countInputValueTarget.textContent = currentValue;
        } else {
          this.element.classList.add("collapsed");
          this.countInputValueTarget.textContent = "";
        }
      }
    }
  }
}
